import { render, staticRenderFns } from "./WellInterpretation.vue?vue&type=template&id=31b2b81b&scoped=true"
import script from "./WellInterpretation.vue?vue&type=script&lang=js"
export * from "./WellInterpretation.vue?vue&type=script&lang=js"
import style0 from "./WellInterpretation.vue?vue&type=style&index=0&id=31b2b81b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b2b81b",
  null
  
)

export default component.exports